<nb-select placeholder="Tags auswählen" multiple [(selected)]="selectedTags" *ngIf="showSelect">
  <nb-option *ngFor="let item of tagAttachmentsMap | keyvalue"
             [value]="item.key"
             (mouseenter)="onMouseEnter(item.key)"
             (mouseleave)="onMouseLeave()"
             (click)="selectedTagsChange.emit(this.selectedTags!)">{{item.key}}</nb-option>
</nb-select>
